var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9424 15C28.9424 23.0854 22.5393 29.625 14.6587 29.625C6.77811 29.625 0.375 23.0854 0.375 15C0.375 6.91465 6.77811 0.375 14.6587 0.375C22.5393 0.375 28.9424 6.91465 28.9424 15Z",
    fill: "white",
    stroke: "#19B3B5",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21094 17.3868V19.9018H11.7259L19.1428 12.4849L16.6279 9.96655L9.21094 17.3868ZM21.0874 10.538C21.2115 10.412 21.2811 10.2422 21.2811 10.0654C21.2811 9.88848 21.2115 9.7187 21.0874 9.59268L19.5156 8.02082C19.3896 7.89671 19.2198 7.82715 19.0429 7.82715C18.866 7.82715 18.6962 7.89671 18.5702 8.02082L17.3453 9.25248L19.8603 11.763L21.0874 10.538Z",
    fill: "#29BCC1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon1);
export default __webpack_public_path__ + "static/media/edit_icon1.508369b225ee49e4c3b89df82aa1424c.svg";
export { ForwardRef as ReactComponent };